module.exports = __webpack_public_path__ + "static/media/settings.63ecea47.png";